import React, { useState, useEffect } from 'react';




const DivisionData = ({ sel, save, users }) => {
    let [title, setTitle] = useState("");
    let [selUsers, setSelUsers] = useState(new Set());


    
    useEffect(() => {
        if (!sel) {
            return;
        }
        setTitle(sel.Title);
        let s = new Set();
        sel.Users.forEach(c => s.add(c));
        setSelUsers(s);
    }, [sel]);


    const checkUser = (user) => {
        if (selUsers.has(user)) {
            selUsers.delete(user)
        }
        else {
            selUsers.add(user);
        }

        let s = new Set(Array.from(selUsers));

        setSelUsers(s);
    }


    const DoSave = () => {
        let data = {
            DivisionId: sel.DivisionId,
            Title: title,
            Users: Array.from(selUsers)
        };
        save(data);
    }

    if (!sel) {
        return null;
    }

    
    return (
        <div className="container">
            <div className="form-row">
                <div className="form-group col-md-12">
                    <label>Отдел/дирекция</label>
                    <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="form-control" />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-12">
                    {
                        users.map(item =>
                            <div className="form-check" key={item.username}>
                                <input type="checkbox" checked={selUsers.has(item.username)} onChange={(e) => checkUser(item.username)} className="form-check-input" />
                                <label>{item.fullname}</label>
                            </div>
                        )


                    }
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-12">
                    <button className="btn btn-primary" onClick={DoSave}>Запис</button>
                </div>
            </div>
        </div>
    );


}


export default DivisionData;

